var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DataListStateful',{attrs:{"title":"Запросы","resource":"shipment-requests","store":"shipmentRequests","add-route":{ name: 'shipment-request-new' },"columns":_vm.columns,"filter-options":_vm.filter}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }